import { useIdentityVerificationConfirmedBanner } from "@contexts/identityVerificationConfirmedBanner/IdentityVerificationConfirmedBannerProvider";
import { useIdentityVerificationPanel } from "@contexts/identityVerificationPanel/IdentityVerificationPanelProvider";
import useIdentityVerification from "@hooks/user/useIdentityVerification";
import { AlertBanner, Button, Text, Title } from "@runwayhealth/runway-components-react";

const IdentityVerificationBanner = () => {
  const { status } = useIdentityVerification();
  const { open } = useIdentityVerificationPanel();
  const { isDismissed: isConfirmedBannerDismissed, dismiss } =
    useIdentityVerificationConfirmedBanner();

  if (status === "not_requested") return null;

  if (status === "confirmed" && isConfirmedBannerDismissed) return null;

  if (status === "awaiting_confirmation") {
    return (
      <div className="identity-verification-banner-container">
        <AlertBanner variant="info" isRounded>
          <AlertBanner.Message>
            <Title as="h3" size="md-bold" noMarginBottom>
              In review
            </Title>
            <Text size="sm">We have your ID and are getting it to your clinician now.</Text>
          </AlertBanner.Message>
        </AlertBanner>
      </div>
    );
  }

  if (status === "confirmed") {
    return (
      <div className="identity-verification-banner-container">
        <AlertBanner variant="success" isRounded>
          <AlertBanner.Message>
            <Title as="h3" size="md-bold" noMarginBottom>
              Identity verified
            </Title>
            <Text size="sm">Your photo ID has been confirmed.</Text>
          </AlertBanner.Message>
          <AlertBanner.Buttons>
            <Button
              size="sm"
              iconName="X"
              isIconOnly
              variant="outline"
              aria-label="Dismiss"
              onClick={dismiss}
            />
          </AlertBanner.Buttons>
        </AlertBanner>
      </div>
    );
  }

  return (
    <div className="identity-verification-banner-container">
      <AlertBanner variant="info" isRounded>
        <AlertBanner.Message>
          <Title as="h3" size="md-bold" noMarginBottom>
            ID Verification
          </Title>
          <Text size="sm">
            Your physician requires a photo of your ID for patient verification before your
            consultation can be finalized - a driver's license, passport or state ID is accepted.
          </Text>
        </AlertBanner.Message>
        <AlertBanner.Buttons>
          <Button size="sm" variant="outline" iconName="ArrowRight" iconPosition="right" onClick={open}>
            Upload ID
          </Button>
        </AlertBanner.Buttons>
      </AlertBanner>
    </div>
  );
};

export default IdentityVerificationBanner;
